var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#0D99AC",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8164 25.0269L24.2066 29.5977C24.4034 29.8026 24.7311 29.8026 24.9278 29.5977L31.5351 22.7187",
    stroke: "#0D99AC",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7912 11H19.3379C18.9153 11 18.5422 11.2706 18.3724 11.6576C16.9693 14.8555 14.5216 15.6396 13.1544 15.82C12.6067 15.8923 12.1143 16.3029 12.0774 16.8541C11.6232 23.6477 12.802 36.1415 25.6751 40.9963C25.9113 41.0853 26.183 41.0775 26.4135 40.9747C39.2259 35.255 39.8939 21.4439 39.1311 16.5864C39.0625 16.15 38.6889 15.8496 38.2521 15.7831C35.1922 15.3172 33.5071 13.2424 32.7897 11.6821C32.6075 11.2858 32.2273 11 31.7912 11Z",
    stroke: "#0D99AC",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsurance);
export default __webpack_public_path__ + "static/media/insurance.9f54a5dabda95763b5f7d613a5b5c0ad.svg";
export { ForwardRef as ReactComponent };